export default __webpack_public_path__ + "static/media/flag-republic-of-kosovo.66bd13fb.svg";